import { createListSlice } from 'redux/utils'

const slice = createListSlice('ShortCollection')
export const { actions } = slice
export default slice.reducer
